import { makeStyles } from '@rbx/ui';

const useAssistantNavStyles = makeStyles()((theme) => ({
  assistantIcon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginTop: -2,
    marginRight: theme.spacing(1),
  },
}));

export default useAssistantNavStyles;
